import { BoostConfig, ChargingSchedule } from 'src/Libs/flow/installation/forms'

interface DisabledSunModeDaysReturnType {
  disabledDays: {
    monday: boolean
    tuesday: boolean
    wednesday: boolean
    thursday: boolean
    friday: boolean
    saturday: boolean
    sunday: boolean
  }[]
  areAllDaysSelected: boolean
}
/**
 * For each schedule entry, it returns the days that are selected in another entry, and therefore should be disabled.
 * It also returns a boolean that is true is all days are selected
 */
export function getDisabledSunModeDays(schedule: ChargingSchedule | BoostConfig): DisabledSunModeDaysReturnType {
  const days = {
    monday: schedule.findIndex(({ weekDays }) => weekDays.monday),
    tuesday: schedule.findIndex(({ weekDays }) => weekDays.tuesday),
    wednesday: schedule.findIndex(({ weekDays }) => weekDays.wednesday),
    thursday: schedule.findIndex(({ weekDays }) => weekDays.thursday),
    friday: schedule.findIndex(({ weekDays }) => weekDays.friday),
    saturday: schedule.findIndex(({ weekDays }) => weekDays.saturday),
    sunday: schedule.findIndex(({ weekDays }) => weekDays.sunday),
  }

  const disabledDays = schedule.map((_entry, index) => ({
    monday: isDayDisabled(days.monday, index),
    tuesday: isDayDisabled(days.tuesday, index),
    wednesday: isDayDisabled(days.wednesday, index),
    thursday: isDayDisabled(days.thursday, index),
    friday: isDayDisabled(days.friday, index),
    saturday: isDayDisabled(days.saturday, index),
    sunday: isDayDisabled(days.sunday, index),
  }))

  const areAllDaysSelected = Object.values(days).every(day => day !== -1)

  return {
    disabledDays,
    areAllDaysSelected,
  }
}

/**
 * Is there a schedule that has this day selected that is NOT this schedule?
 *
 * @param dayIndex The index of the schedule entry that has this day as true. -1 if there is no such schedule.
 * @param scheduleIndex The index of the schedule entry to check if this day should be disabled.
 */
function isDayDisabled(dayIndex: number, scheduleIndex: number): boolean {
  if (dayIndex === -1) return false // Day is not selected on any schedule entry. Enable.

  return dayIndex !== scheduleIndex // Day is selected on another schedule entry. Disable.
}
